import classNames from 'classnames';
import React, { FC } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import Icon, { Sizes } from '../IconDS22';
import styles from './WarningDS22.module.scss';

export type WarningProps = {
  /**
   * Icon alignment, defaults to center if omitted
   */
  alignIcon?: 'start' | 'end';
  children: React.ReactNode;
  centered?: boolean;
  showIcon?: boolean;
  iconSize?: Sizes;
  variant?: 'info' | 'error';
};

const WarningDS22: FC<WarningProps> = ({
  alignIcon,
  children,
  centered,
  showIcon,
  iconSize = 'l',
  variant = 'info',
}) => (
  <div className={getClassNames(styles, 'root', classNames(variant, { centered }))}>
    {showIcon && (
      <Icon
        id="warning"
        size={iconSize}
        className={getClassNames(styles, 'icon', classNames(alignIcon && `align-${alignIcon}`))}
      />
    )}
    <div>
      {children}
    </div>
  </div>
);

export default WarningDS22;
